import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.button_type - The type of button that was clicked, available value: 'floating' | 'header'
 */
export const onTrackMiniCartButtonClick = async (payload) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.MiniCartButtonClick,
    data: {
      button_type: payload.button_type,
    },
  });
};
